<template>
    <div class="panel">
        <div class="panel-body">
            <div class="form-group has-feedback has-feedback-left">
                <label>Title:</label>
                <input class="form-control" placeholder="Title" v-model="title">
                <div class="form-control-feedback">
                    <i class="fas fa-heading text-size-base text-muted"></i>
                </div>
            </div>
            <div class="form-group has-feedback has-feedback-left">
                <label>Tags (separated by comma):</label>
                <input class="form-control" placeholder="Tags" v-model="tagsStr">
                <div class="form-control-feedback">
                    <i class="fas fa-tags text-size-base text-muted"></i>
                </div>
            </div>
            <div class="form-group has-feedback has-feedback-left">
                <label>Meta description [SEO; 135-160 characters] ({{desc.length}}):</label>
                <input class="form-control" placeholder="Meta description" v-model="desc">
                <div class="form-control-feedback">
                    <i class="fas fa-info-circle text-size-base text-muted"></i>
                </div>
            </div>
            <div class="form-group has-feedback has-feedback-left">
                <label>Main image:</label>
                <input class="form-control" placeholder="Image" v-model="image">
                <div class="form-control-feedback">
                    <i class="fas fa-image text-size-base text-muted"></i>
                </div>
            </div>
            <div class="form-group has-feedback has-feedback-left">
                <label>Preview:</label>
                <Summernote class="form-control"
                            name="preview"
                            :model="preview"
                            :height="150"
                            v-on:change="value => { preview = value }"/>
            </div>
            <div class="form-group has-feedback has-feedback-left">
                <label>Content:</label>
                <Summernote class="form-control"
                            name="content"
                            :model="content"
                            :height="400"
                            v-on:change="value => { content = value }"/>
            </div>
        </div>
        <div class="panel-footer">
            <div class="heading-elements">
                <button type="button" class="btn btn-primary heading-btn pull-right" @click="proccessAdd">Add post
                </button>
            </div>
        </div>
    </div>
</template>

<script>
  import {mapGetters, mapState} from 'vuex'
  import swal from 'sweetalert2'
  import Summernote from './Summernote.vue'

  export default {
    name: 'new-blog-item',
    components: {Summernote},
    computed: {
      ...mapGetters(['getUser', 'loggedIn']),
      ...mapState(['mode'])
    },
    data() {
      return {
        isPublic: true,
        title: '',
        desc: '',
        preview: '',
        content: '',
        image: '',
        tagsStr: ''
      }
    },
    methods: {
      proccessAdd() {
        if (this.loggedIn) {
          var item = {
            id: this.sanitizeTitle(this.title),
            owner: this.getUser.uid,
            private: !this.isPublic,
            date: new Date().toDateString(),
            day: this.countDays(),
            title: this.title,
            description: this.desc,
            content: this.content,
            preview: (this.preview !== '') ? this.preview : null,
            image: this.image,
            likes: 1,
            tags: this.tagsStr.split(',').map(item => item.trim().toLowerCase())
          };
          this.$emit('blogItemAdded', item);
          this.resetData();
          swal(
            'Awesome!',
            'New blog post saved',
            'success')
        } else {
          swal(
            'Please login!',
            'In order to add new puzzle you need to be logged in.',
            'info')
        }
      },
      countDays() {
        let oneDay = 24 * 60 * 60 * 1000;
        let firstDate = new Date('2018-03-15');
        let secondDate = new Date();

        return Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / (oneDay)));
      },
      resetData() {
        this.title = '';
        this.content = '';
        this.image = '';
        this.tagsStr = '';
      },
      sanitizeTitle(title) {
        let slug = '';
        let titleLower = title.toLowerCase();
        slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
        slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
        slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
        slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');
        slug = slug.replace(/đ/gi, 'd');
        slug = slug.replace(/\s*$/g, '');
        slug = slug.replace(/\s+/g, '-');

        return slug;
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// NewBlogItem.vue?17e2f1c7